import { createI18n } from 'vue-i18n';
import en from './languages/en';
import zh from './languages/zh';
import ja from './languages/ja';

export const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en,
        zh,
        ja
    }
});

// 受支持语言列表的单一事实源（与认证入口 resolver 共用，见 src/core/auth/supportedLangs.js）。
// 新增语言只改 supportedLangs.js 一处，此处自动同步。
import { SUPPORTED_LANGS } from '@/core/auth/supportedLangs'

export const supportedLanguages = SUPPORTED_LANGS;
export const defaultLanguage = 'en';

// 从 URL 路径中提取语言代码
export function getLocaleFromPath(path) {
    const firstSegment = path.split('/')[1];
    return supportedLanguages.includes(firstSegment) ? firstSegment : null;
}

// 获取用户偏好语言
export function getUserPreferredLanguage() {
    // 1. 检查localStorage中保存的语言设置
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && supportedLanguages.includes(savedLanguage)) return savedLanguage;

    // 2. 检查浏览器语言设置并保存
    const browserLang = navigator.language.split('-')[0];
    localStorage.setItem('browserLanguage', browserLang);

    if (supportedLanguages.includes(browserLang)) {
        // localStorage.setItem('language', browserLang);
        return browserLang;
    }

    // 3. 默认使用英语并保存
    // localStorage.setItem('language', defaultLanguage);
    return defaultLanguage;
}